<div class="container-xxl py-5">
  <div class="container">
    <!-- News Start -->
    <div class="row g-5 align-items-center">
      <app-carousel [items]="newsCarousel"></app-carousel>
    </div>
    <!-- News End -->

    <!-- Vision Start -->
    <div class="row g-5 align-items-center">
      <div class="col-lg-6 wow fadeInUp" data-wow-delay="0.1s">
        <h1 class="mb-4">{{ DATA.vision.title[language] }}</h1>
        <p>
          {{ DATA.vision.content[language] }}
        </p>
      </div>
      <div class="col-lg-6 about-img wow fadeInUp" data-wow-delay="0.5s">
        <div class="row">
          <div class="col-12 text-center">
            <img
              class="img-fluid w-175 rounded-circle bg-light p-3"
              src="assets/img/{{ DATA.vision.image }}"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
    <!-- Vision End -->

    <!-- ISO Start -->
    <div class="container-xxl py-5">
      <div class="container">
        <div class="row g-5 align-items-center">
          <div class="col-lg-6 wow fadeInUp" data-wow-delay="0.1s">
            <h1 class="mb-4">
              {{ DATA.iso.title[language] }}
            </h1>
            <p>
              {{ DATA.iso.brief[language] }}
            </p>
          </div>
          <div class="col-lg-6 about-img wow fadeInUp" data-wow-delay="0.5s">
            <div class="row">
              <div class="col-12 text-center">
                <img
                  class="img-fluid w-75 rounded-circle bg-light p-3"
                  src="assets/img/{{ DATA.iso.images[0] }}"
                  alt=""
                />
              </div>
              <!-- ISO FR Start -->
              <div class="col-6 text-start" style="margin-top: -150px">
                <img
                  class="img-fluid w-100 rounded-circle bg-light p-3"
                  style="height: 80%"
                  src="assets/img/{{ DATA.iso.images[1] }}"
                  alt=""
                />
                <br /><br />
                <a
                  class="btn btn-primary rounded-pill py-3 px-5 align-items-center"
                  (click)="openIsoArticle(DATA.iso.frContent)"
                  >{{ "read_more" | translate }}</a
                >
              </div>
              <!-- ISO FR End -->
              <!-- ISO AR Start-->
              <div class="col-6 text-end" style="margin-top: -150px">
                <img
                  class="img-fluid w-100 rounded-circle bg-light p-3"
                  style="height: 80%"
                  src="assets/img/{{ DATA.iso.images[2] }}"
                  alt=""
                />
                <br /><br />
                <a
                  class="btn btn-primary rounded-pill py-3 px-5 align-items-center"
                  (click)="openIsoArticle(DATA.iso.arContent)"
                  >{{ "read_more" | translate }}</a
                >
              </div>
              <!-- ISO AR End-->
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- ISO End -->

    <!-- Testimonials Start -->
    <div
      class="row g-10 wow fadeInUp align-items-center"
      data-wow-delay="0.1s"
      style="max-width: 600px"
    >
      <h1 class="mb-3">{{ "testimonials_title" | translate }}</h1>
      <p>
        {{ "testimonials_text" | translate }}
      </p>
    </div>
    <app-testimonial [items]="testimonialData"></app-testimonial>
    <!-- Testimonials End -->
    <br /><br /><br />
    <!-- Featured Images Start -->
    <div class="row g-10 wow fadeInUp align-items-center">
      <h1 class="mb-4">{{ "gallery" | translate }}</h1>
      <app-photogallery [images]="galleryData"></app-photogallery>
    </div>
    <!-- Featured Images End -->
    <br /><br /><br />
    <!-- Redirect to BAC Site Start -->
    <div class="row g-5 align-items-center">
      <h1 class="mb-4">{{ "bac_redirect_title" | translate }}</h1>
      <div class="row g-0">
        <div
          class="col-lg-6 wow fadeIn"
          data-wow-delay="0.1s"
          style="min-height: 400px"
        >
          <div class="position-relative h-100">
            <img
              class="position-absolute w-100 h-100 rounded"
              src="assets/img/bac_redirect.jpg"
              style="object-fit: cover"
            />
          </div>
        </div>
        <div class="col-lg-6 wow fadeIn" data-wow-delay="0.5s">
          <div class="h-100 d-flex flex-column justify-content-center p-5">
            <p class="mb-4">
              {{ "bac_redirect_text" | translate }}
            </p>
            <a
              class="btn btn-primary py-3 px-5"
              href="https://www.bac.ecole-girard.com/"
              >{{ "go_to_bac_site" | translate }}</a
            >
          </div>
        </div>
      </div>
    </div>
    <br /><br /><br />
    <!-- Redirect to BAC Site End -->
  </div>
</div>
